<template>
    <div>
        <van-row style="padding-top: 25px;">
            <van-col :span="2">
                <div
                    style="height: 30px; width: 30px; display: flex; justify-content: flex-start; align-items: center; padding: 5px 0px 5px 0px;;">
                    <img style="height: 100%; width: 100%; object-fit: cover;border-radius: 25px"
                        :src="props.img" />
                </div>
            </van-col>
            <van-col :span="16">
                <div
                    style="display: flex; justify-content: flex-start; align-items: center; padding: 5px 0px 5px 15px;;">
                    <span style="font-weight: 400;font-size: 14px; color: #5f6368;">{{ name }}</span>
                </div>
            </van-col>
            <van-col :span="6">
                <div style=" display: flex; justify-content: flex-end; align-items: center; padding: 5px 0px 5px 0px;;">
                    <img style="height: 20px; width: 20px; object-fit: cover;" src="@/assets/download/more_vert.png" />

                </div>
            </van-col>

        </van-row>
        <van-row style="margin-top: 5px;">
            <van-col span="6">
                <div style=" display: flex; justify-content: flex-start; flex-direction: column;">

                    <div style=" display: flex; justify-content: flex-start; flex-direction: row; margin-top: 4px;">
                        <van-icon style="padding: 2px;font-weight: 600;" v-for="i in 5" :key="i" name="star" size="10"
                            color="#01875f" />

                    </div>
                </div>
            </van-col>
            <van-col span="10">
                <span class="commentText">{{
                    commentDate }}</span>
            </van-col>
        </van-row>
        <van-row style="">
            <van-col span="24">
                <p style="color:#5f6368; margin: 0; line-height: 20px; margin-top: 15px;">{{ comment }}</p>
            </van-col>
        </van-row>
        <van-row style="">
            <van-col span="24">
                <p class="commentText" style="margin-top: 15px;">{{ $t('download.helpFullBy') + ' ' + reviewCount + ' '
                    +
                    $t('donwload.people') }}</p>
            </van-col>
        </van-row>
        <van-row style="margin-top: 5px; align-items: center;">
            <van-col span="10">
                <p class="commentText">{{ $t('download.helpFull') }}</p>
            </van-col>
            <van-col span="4">
                <van-tag :plain="true" class="tagList" style="border: 1px solid #dadce0;" color="#5f6368" round
                    type="primary">{{ $t('download.yes') }}</van-tag>

            </van-col>
            <van-col span="2">
            </van-col>
            <van-col span="4">
                <van-tag :plain="true" class="tagList" color="#5f6368" style="border: 1px solid #dadce0;" round
                    type="primary">{{ $t('download.no') }}</van-tag>

            </van-col>
        </van-row>
    </div>
</template>
<script setup lang="ts">
import { any } from 'core-js/fn/promise';
import { defineProps, ref } from 'vue';
const props = defineProps({
    img: {
       type: String,
        default: () => ''
    },
    name: {
        type: String,
        default: '',
    },
    comment: {
        type: String,
        default: '',
    },
    commentDate: {
        type: String,
        default: '',
    },
    reviewCount: {
        type: Number,
        default: () => 0,
    },
})
const comment1 = ref(`<p style="margin: 0;">O jogo é bom , mais precisa de um incentivo, no
geral eu gostei bastante Dá pra pessoa distrair e
jogar é muito saudável ! Amei os porquinhos kkk</p>`)

</script>

<style scoped>
.commentText {
    font-size: 13px;
    font-weight: 500;
    color: rgb(95, 99, 104);
    margin: 0;
}

.progressBarText {
    margin-right: 10px;
    line-height: 5px;
    font-size: 12px;
    color: #5f6368;
}

.tagList {
    width: 100%;
    justify-content: center;
    padding: 5px 0px;
}
</style>